import { useState, useRef, useEffect } from "react";
import { Row, Col, Form, Button, Modal, Dropdown } from "react-bootstrap";
import { iminioBackend } from "../../api/iminio_provider";
import i18n from "../../plugins/i18n";

function EditCondominiumForm({
  listId,
  adminList,
  systemTypeList,
  condData,
  changeView,
  userGroup,
  reloadList,
}) {
  let isMounted = false;
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isFieldsLoading, setFieldsLoading] = useState(true);
  const [isEditing, setEditing] = useState(false);
  const [isDeleting, setDeleting] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [photoBase64, setPhotoBase64] = useState("");
  const [photoLoading, setPhotoLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [condominiumSystemsText, setCondominiumSystemsText] = useState("");
  const [admins, setAdmins] = useState([]);

  const [addressSteet, setAddresStreet] = useState(condData.address_street);
  const [addressPostalCode, setAddressPostalCode] = useState(
    condData.address_postcode
  );
  const [addressCity, setAddressCity] = useState(condData.address_city);
  const [addressProvince, setAddressProvince] = useState(
    condData.address_state_province
  );

  const addressStreetField = useRef("");
  const addressPostalCodeField = useRef("");
  const addressProvinceField = useRef("");
  const addressCityField = useRef("");
  //   const addressField = useRef('');
  const managedByField = useRef(condData.managed_by_id);
  const contactNameField = useRef("");
  const thirdPartyResponsableField = useRef(
    condData.is_third_party_responsable
  );
  const timeAvailabilityField = useRef("");
  const hasKeysField = useRef(condData.has_keys);
  const systemTypeField = useRef(condData.system_types || []);
  const notesField = useRef(condData.notes || "");

  const fetchUserList = async () => {
    let tempAdminList = await iminioBackend
      .list_admin_user_options()
      .catch((e) => console.log(e));

    setAdmins(tempAdminList ? tempAdminList.users : []);
  };

  const handleSubmitEdit = async () => {
    setLoading(true);
    setError("");
    if (
      !timeAvailabilityField?.current?.value ||
      timeAvailabilityField?.current?.value.length === 0
    ) {
      setTimeout(() => {
        setError("Fasce orarie è un campo obbligatorio richiesto.");
        setLoading(false);
      }, 150);
      return;
    }
    await iminioBackend
      .edit_condominium(condData.id, {
        managed_by_id: managedByField.current.value,
        contact_person_name: contactNameField.current.value,
        system_types: systemTypeField.current,
        is_third_party_responsable: thirdPartyResponsableField.current.value,
        time_availability: timeAvailabilityField.current.value,
        has_keys: hasKeysField.current.value,
        notes: notesField.current.value,
        address_city: addressCityField.current.value,
        address_postcode: addressPostalCodeField.current.value,
        address_state_province: addressProvinceField.current.value,
        address_street: addressStreetField.current.value,
      })
      .then((data) => {
        setAddresStreet(addressStreetField.current.value);
        setAddressCity(addressCityField.current.value);
        setAddressProvince(addressProvinceField.current.value);
        setAddressPostalCode(addressPostalCodeField.current.value);

        setMessage(i18n.t("messages.saved_success").replace("{1}", ""));
        setEditing(false);
        setLoading(false);
        setTimeout(() => {
          setMessage("");
        }, 3500);
      })
      .catch((e) => {
        console.log(e);
        switch (e.response?.data?.status?.code) {
          case "ERR_INVALID_FIELDS":
            let details = e.response.data.details[0];
            if (details.code === "string.empty")
              setError(
                i18n
                  .t("errors.required_field")
                  .replace(
                    "{1}",
                    i18n.t(`models.condominium.fields.${details.field}`)
                  )
              );
            else if (
              [
                "number.base",
                "string.pattern.base",
                "date.base",
                "any.base",
                "string.email",
              ].includes(details.code)
            )
              setError(
                i18n
                  .t("errors.invalid_field")
                  .replace(
                    "{1}",
                    i18n.t(`models.condominium.fields.${details.field}`)
                  )
              );
            else setError(i18n.t("errors.unknown"));
            break;
          case "ERR_ALREADY_EXISTS":
            let details2 = e.response.data.details;
            setError(
              `${i18n.t(`models.condominium.fields.${details2.field}`)} ${
                details2.value
              } ` + i18n.t("errors.already_in_use")
            );
            break;
          default:
            setError(i18n.t("errors.unknown"));
            break;
        }
        setLoading(false);
      });
  };

  const handleSubmitDelete = async () => {
    let func = iminioBackend.delete_condominium;
    if (condData.is_deleted === true) func = iminioBackend.restore_condominium;
    setLoading(true);
    await func(condData.id)
      .then((response) => {
        setLoading(false);
        setDeleting(false);
        reloadList();
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setEditing(false);
      });
  };

  const toggleSystemTypeFromList = async (stypeId) => {
    if (
      !systemTypeField.current ||
      systemTypeField.current?.findIndex((e) => e === stypeId) < 0
    )
      systemTypeField.current?.push(stypeId);
    else
      systemTypeField.current = systemTypeField.current?.filter(
        (e) => e !== stypeId
      );

    if (!systemTypeField.current || systemTypeField.current.length == 0) {
      setCondominiumSystemsText("Nessuno");
    } else {
      let temp = [];
      for (let i = 0; i < systemTypeField.current.length; i++) {
        let found = systemTypeList?.choices.find(
          (e) => parseInt(e.value) === parseInt(systemTypeField.current[i])
        );
        if (found) temp.push(found.text);
      }
      setCondominiumSystemsText(temp.join(", "));
    }
  };

  const handleCancelEdit = () => {
    managedByField.current.value = condData.managed_by_id;
    contactNameField.current.value = condData.contact_person_name;
    thirdPartyResponsableField.current.value =
      condData.is_third_party_responsable;
    timeAvailabilityField.current.value = condData.time_availability;
    hasKeysField.current.value = condData.has_keys;
    systemTypeField.current.value = condData.system_types;
    setEditing(false);
  };

  const goToInterventions = () => {
    localStorage.setItem(
      "prefilter",
      JSON.stringify({ condominium_id: condData.id })
    );
    setTimeout(() => {
      changeView("technical_intervention");
    }, 150);
  };

  const openFileInNewWindow = async (type = "file") => {
    if (type === "file") {
      setFileLoading(true);
      await iminioBackend.get_condominium_file(condData.id).then((response) => {
        const base64 = response.file.base64;
        const binStr = atob(base64.split(";")[1].split(",")[1].trim());
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        const blob = new Blob([arr], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.download = `${condData.name}.pdf`;
        a.href = url;
        a.click();
        setFileLoading(false);
      });
    } else if (type === "photo") {
      setPhotoLoading(true);
      setPhotoBase64("");
      await iminioBackend
        .get_condominium_photo(condData.id)
        .then((response) => {
          setPhotoBase64("");
          setTimeout(() => {
            setPhotoBase64(response.file.base64);
            setPhotoLoading(false);
          }, 300);
        });
    }
  };

  useEffect(() => {
    const init = async () => {
      fetchUserList();
      setTimeout(() => {
        setLoading(false);
        setFieldsLoading(false);
        let temp = [];
        for (let i = 0; i < condData?.system_types?.length; i++) {
          let found = systemTypeList?.choices.find(
            (e) => parseInt(e.value) === parseInt(systemTypeField.current[i])
          );
          if (found) temp.push(found.text);
        }
        setCondominiumSystemsText(temp.join(", "));
      }, 300);
    };
    if (isMounted === false) {
      init();
      isMounted = true;
    }
  }, []);

  const openFileDialogAndUploadType = (type = "file") => {
    var f = document.createElement("input");
    f.style.display = "none";
    f.type = "file";
    f.name = "file";
    if (type === "file") f.accept = ".pdf";
    document.getElementById("dashboard-view-main-container").appendChild(f);
    f.click();
    f.addEventListener("change", () => {
      if (f.files) {
        var reader = new FileReader();
        reader.readAsDataURL(f.files[0]);
        reader.onload = async function () {
          setLoading(true);
          if (type === "file") {
            const fileData = {
              base64: reader.result,
              filename: f.files[0].name,
            };
            const dataType = fileData.base64?.split(";")?.[0]?.split(":")?.[1];
            if (dataType?.toLowerCase() !== "application/pdf") {
              setLoading(false);
              setError(i18n.t("errors.invalid_pdf"));
              setTimeout(() => {
                setError("");
              }, 5600);
              return;
            }
            await iminioBackend
              .attach_file_to_condominium(condData.id, fileData)
              .then(() => {
                setMessage(
                  i18n
                    .t("messages.uploaded_success")
                    .replace("{1}", i18n.t("words.file"))
                );
                condData.has_file = true;
                setLoading(false);
                setEditing(false);
                setTimeout(() => {
                  setMessage("");
                }, 3600);
              })
              .catch((e) => {
                console.log(e);
                setError(i18n.t("errors.unknown"));
                setTimeout(() => {
                  setError("");
                }, 5600);
              });
          } else if (type === "photo") {
            await iminioBackend
              .attach_photo_to_condominium(condData.id, reader.result)
              .then(() => {
                setMessage(
                  i18n
                    .t("messages.uploaded_success_f")
                    .replace("{1}", i18n.t("words.photo"))
                );
                condData.has_photo = true;
                setLoading(false);
                setEditing(false);
                setTimeout(() => {
                  setMessage("");
                }, 3600);
              })
              .catch((e) => {
                console.log(e);
                setError(i18n.t("errors.unknown"));
                setTimeout(() => {
                  setError("");
                }, 5600);
              });
          }
        };
        reader.onerror = function (error) {
          setLoading(false);
          console.log(error);
        };
      }
    });
  };

  const buildCondominiumAddress = () => {
    let streetStr = "";
    if (addressSteet) streetStr += `${addressSteet} `;
    if (addressCity) streetStr += `, ${addressCity} `;
    if (addressPostalCode) streetStr += ` (${addressPostalCode}) `;
    if (addressProvince) streetStr += `, ${addressProvince} `;
    return streetStr;
  };

  useEffect(() => {
    if (photoBase64 !== "") {
      setTimeout(() => {
        setPhotoLoading(false);
        setShowImageModal(true);
      }, 350);
    }
  }, [photoBase64]);

  return (
    <>
      <Row className="edit-condominium-form-container px-2">
        <Col xs={12} md={6} className="justify-content-start">
          <Form.Group
            as={Row}
            className="mb-1 justify-content-between"
            controlId="formPlaintextEmail"
          >
            <Form.Label column xs={3} md={2}>
              <span className="fg-orange text-9">
                <b>Indirizzo:</b>
              </span>
            </Form.Label>
            {!isEditing && !isLoading ? (
              <Col
                xs={9}
                md={10}
                className="d-flex justify-content-start align-content-center py-2 text-9"
              >
                {buildCondominiumAddress()}
              </Col>
            ) : (
              <Col xs="10">
                <Row className="gap-1">
                  <Col xs="5">
                    <Form.Control
                      plaintext={!isEditing && !isLoading}
                      ref={addressStreetField}
                      readOnly={!isEditing && !isLoading}
                      defaultValue={addressSteet}
                    />
                  </Col>
                  <Col xs="5">
                    <Form.Control
                      plaintext={!isEditing && !isLoading}
                      ref={addressPostalCodeField}
                      readOnly={!isEditing && !isLoading}
                      defaultValue={addressPostalCode}
                    />
                  </Col>
                </Row>
                <div style={{ height: "4px" }}></div>
                <Row className="gap-1">
                  <Col xs="5">
                    <Form.Control
                      plaintext={!isEditing && !isLoading}
                      ref={addressProvinceField}
                      readOnly={!isEditing && !isLoading}
                      defaultValue={addressProvince}
                    />
                  </Col>
                  <Col xs="5">
                    <Form.Control
                      plaintext={!isEditing && !isLoading}
                      ref={addressCityField}
                      readOnly={!isEditing && !isLoading}
                      defaultValue={addressCity}
                    />
                  </Col>
                </Row>
              </Col>
            )}
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-start">
          <Form.Group
            as={Row}
            className="mb-1 align-items-center"
            controlId="formPlaintextEmail"
          >
            <Form.Label column xs="5">
              <span className="fg-orange">
                <b>Amministratore:</b>
              </span>
            </Form.Label>
            <Col xs="7">
              {userGroup === "technician" ? (
                <span>{condData.manager_full_name}</span>
              ) : (
                admins.length > 0 && (
                  <Form.Select
                    ref={managedByField}
                    defaultValue={condData.managed_by_id}
                    disabled={isLoading || !isEditing}
                  >
                    <option>Open this select menu</option>
                    {admins?.map((e) => {
                      return (
                        <option key={e.id} value={e.id}>
                          {e.first_name} {e.last_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                )
              )}
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-start">
          <Form.Group as={Row} className="mb-1" controlId="formPlaintextEmail">
            <Form.Label column xs="7">
              <span className="fg-orange">
                <b>Referente condominiale:</b>
              </span>
            </Form.Label>
            <Col xs="5">
              <Form.Control
                plaintext={!isEditing && !isLoading}
                ref={contactNameField}
                readOnly={!isEditing && !isLoading}
                defaultValue={condData.contact_person_name}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-start">
          <Form.Group
            as={Row}
            className="mb-1 align-items-center"
            controlId="formPlaintextEmail"
          >
            <Form.Label column xs="9">
              <span className="fg-orange">
                <b>Terzo Responsabile?</b>
              </span>
            </Form.Label>
            <Col xs="3">
              <Form.Select
                ref={thirdPartyResponsableField}
                defaultValue={condData.is_third_party_responsable}
                disabled={!isEditing || isLoading}
              >
                <option value="true">Si</option>
                <option value="false">No</option>
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-start">
          <Form.Group
            as={Row}
            className="mb-1 align-items-center"
            controlId="formPlaintextEmail"
          >
            <Form.Label column xs="5">
              <span className="fg-orange">
                <b>{i18n.t("models.condominium.fields.time_availability")}</b>
              </span>
            </Form.Label>
            <Col xs="7">
              <Form.Control
                plaintext={!isEditing && !isLoading}
                readOnly={!isEditing && !isLoading}
                defaultValue={condData.time_availability}
                ref={timeAvailabilityField}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-start">
          <Form.Group
            as={Row}
            className="mb-1 align-items-center"
            controlId="formPlaintextEmail"
          >
            <Form.Label column xs="9">
              <span className="fg-orange">
                <b>Telegestione?</b>
              </span>
            </Form.Label>
            <Col xs="3" md="3">
              <Form.Select
                ref={hasKeysField}
                defaultValue={condData.has_keys}
                disabled={!isEditing || isLoading}
              >
                <option value="true">Si</option>
                <option value="false">No</option>
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12}>
          <Row className="d-flex justify-content-start align-items-center align-content-center">
            <Col xs={12} md={6} className="">
              <Form.Label column xs="12">
                <span className="fg-orange">
                  <b>Tipologia Impianto</b>
                </span>
              </Form.Label>
              {/* <Form.Select ref={systemTypeField} disabled={isLoading || !isEditing} defaultValue={condData.system_types}>
                            <option>Seleziona Tipologia</option>
                            {systemTypeList?.choices?.map(e=>{
                                return <option key={`systype-${e.value}`} value={e.value}>
                                    {e.text}
                                </option>
                            })}
                        </Form.Select> */}
              <Dropdown>
                <Dropdown.Toggle
                  disabled={isLoading || !isEditing}
                  className="bg-blue fg-white"
                  variant="orange"
                  id="condominium-systemtype-dropdown"
                >
                  <span className="text-10" style={{ textWrap: "balance" }}>
                    {condominiumSystemsText}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {systemTypeList?.choices?.map((e) => {
                    return (
                      <Dropdown.Item
                        href="#"
                        key={`systype-${e.value}`}
                        value={e.value}
                        onClick={() => toggleSystemTypeFromList(e.value)}
                      >
                        {systemTypeField.current.includes(parseInt(e.value)) ||
                        systemTypeField.current.includes("" + e.value) ? (
                          <i className="mdi mdi-check-circle text-10 fg-green me-1"></i>
                        ) : (
                          ""
                        )}
                        {e.text}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={6} md={3} className="pt-4 d-flex justify-content-center">
              {userGroup === "technician" ? (
                ""
              ) : condData.has_file === true ? (
                isEditing === true ? (
                  <Button
                    className={`px-3 corner-round bg-orange fg-white`}
                    variant="blue"
                    size={"sm"}
                    onClick={() => openFileDialogAndUploadType("file")}
                    disabled={fileLoading}
                  >
                    <i className="mdi mdi-upload me-2"></i>
                    Sostituire PDF
                  </Button>
                ) : (
                  <Button
                    className={`px-3 corner-round bg-orange fg-white`}
                    variant="blue"
                    size={"sm"}
                    onClick={() => openFileInNewWindow("file")}
                    disabled={fileLoading}
                  >
                    Visualizza PDF
                    <i className="mdi mdi-open-in-new ms-2"></i>
                  </Button>
                )
              ) : (
                <Button
                  className={`px-3 corner-round bg-orange fg-white`}
                  variant="blue"
                  size={"sm"}
                  onClick={() => {
                    openFileDialogAndUploadType("file");
                  }}
                  disabled={!isEditing}
                >
                  <i className="mdi mdi-upload me-2"></i>
                  Carica PDF
                </Button>
              )}
            </Col>
            <Col xs={6} md={3} className="pt-4 d-flex justify-content-center">
              {userGroup === "technician" ? (
                ""
              ) : condData.has_photo === true ? (
                isEditing === true ? (
                  <Button
                    className={`px-3 corner-round bg-orange fg-white`}
                    variant="blue"
                    size={"sm"}
                    onClick={() => openFileDialogAndUploadType("photo")}
                    disabled={photoLoading}
                  >
                    <i className="mdi mdi-upload me-2"></i>
                    Sostituire Foto
                  </Button>
                ) : (
                  <Button
                    className={`px-3 corner-round bg-orange fg-white`}
                    variant="blue"
                    size={"sm"}
                    onClick={() => openFileInNewWindow("photo")}
                    disabled={photoLoading}
                  >
                    Visualizza Foto
                    <i className="mdi mdi-open-in-new ms-2"></i>
                  </Button>
                )
              ) : (
                <Button
                  className={`px-3 corner-round bg-orange fg-white`}
                  variant="blue"
                  size={"sm"}
                  onClick={() => {
                    openFileDialogAndUploadType("photo");
                  }}
                  disabled={!isEditing}
                >
                  <i className="mdi mdi-upload me-2"></i>
                  Carica Foto
                </Button>
              )}
            </Col>
          </Row>
        </Col>
        <Col xs={12} className="justify-content-start mt-4">
          <Row className="justify-content-center">
            <Col xs={12}>
              <Button
                className={`px-3 corner-round bg-blue fg-white`}
                variant="blue"
                size={"sm"}
                onClick={() => {
                  goToInterventions();
                }}
                disabled={isEditing}
              >
                Visualizza Interventi
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6} className="justify-content-center pe-4 mt-3">
          <Form.Group as={Row} controlId="formPlaintextEmail">
            <Form.Label column xs="1">
              <span className="fg-orange">
                <b>Note</b>
              </span>
            </Form.Label>
            <Col xs="11" className="ps-2">
              <Form.Control
                as="textarea"
                rows="3"
                type="text"
                ref={notesField}
                disabled={!isEditing || isLoading}
                defaultValue={condData.notes}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} className="mt-3">
          <Row className="justify-content-end">
            {!message || message.length === 0 ? (
              ""
            ) : (
              <div className="iminio-error-container bg-green fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                <i className="mdi mdi-check-circle me-2"></i>
                {message}
              </div>
            )}
            {!error || error.length === 0 ? (
              ""
            ) : (
              <div className="iminio-error-container bg-red fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                <i className="mdi mdi-close-circle me-2"></i>
                {error}
              </div>
            )}
          </Row>
        </Col>
        {userGroup === "technician" ? (
          ""
        ) : (
          <Col
            xs={12}
            className="d-flex justify-content-end align-items-center mt-3"
          >
            {!isEditing ? (
              ""
            ) : (
              <>
                <Button
                  className={`px-4 me-2 corner-round bg-gray-darker fg-text`}
                  variant="orange"
                  disabled={isLoading}
                  onClick={() => {
                    handleCancelEdit();
                  }}
                  size={"sm"}
                >
                  <i className="mdi mdi-close me-2"></i>
                  Cancella
                </Button>
                <Button
                  className={`px-5 corner-round bg-orange fg-white`}
                  variant="orange"
                  disabled={isLoading}
                  onClick={() => {
                    handleSubmitEdit();
                  }}
                  size={"sm"}
                >
                  <i className="mdi mdi-content-save me-2"></i>
                  Salva
                </Button>
              </>
            )}
            {isEditing || isDeleting ? (
              ""
            ) : (
              <>
                <Button
                  className={`px-3 corner-round bg-orange fg-white`}
                  variant="orange"
                  onClick={() => {
                    setEditing(true);
                  }}
                  size={"sm"}
                >
                  <i className="mdi mdi-square-edit-outline me-2"></i>
                  Modifica
                </Button>
                <div className="divider-v mx-4"></div>
                {condData.is_deleted === false ? (
                  <Button
                    className={`px-3 corner-round bg-red fg-white`}
                    variant="red"
                    onClick={() => {
                      setDeleting(true);
                    }}
                    size={"sm"}
                  >
                    <i className="mdi mdi-delete me-2"></i>
                    Eliminare
                  </Button>
                ) : (
                  <Button
                    className={`px-3 corner-round bg-green fg-white`}
                    variant="red"
                    onClick={() => {
                      setDeleting(true);
                    }}
                    size={"sm"}
                  >
                    <i className="mdi mdi-delete-restore me-2"></i>
                    Ripristinare
                  </Button>
                )}
              </>
            )}
            {!isDeleting ? (
              ""
            ) : (
              <>
                Vuoi{" "}
                {condData.is_deleted === false ? "eliminare" : "rirpistinare"}{" "}
                questo condominio?
                <Button
                  className={`ms-3 px-3 corner-round bg-orange fg-white`}
                  variant="orange"
                  onClick={() => {
                    setDeleting(false);
                  }}
                  size={"sm"}
                >
                  No
                </Button>
                <div className="divider-v mx-4"></div>
                <Button
                  className={`px-3 corner-round ${
                    condData.is_deleted === false ? "bg-red" : "bg-green"
                  } fg-white`}
                  variant="red"
                  onClick={() => {
                    handleSubmitDelete();
                  }}
                  size={"sm"}
                >
                  Si
                  <i className="mdi mdi-delete ms-2"></i>
                </Button>
              </>
            )}
          </Col>
        )}
      </Row>
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-10">{condData.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row justify-center">
            <img
              className="condominium-image"
              src={photoBase64}
              alt={`${condData.name} logo`}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default EditCondominiumForm;
